import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const artisan: Collection = {
  id: 's-and-p-artisan',
  brandId: 'salt-and-pepper',
  brandName: 'Salt and Pepper',
  icon: 'logo_salt_pepper.png',
  title: 'Artisan',
  subTitle: 'Stijlvol en feestelijk',
  banner: 'artisan/artisan-banner.jpg',
  items: [
    {
      id: 's-and-p-artisan-1',
      collectionImages: [
        {
          image: 'artisan/Artisan_aura_blossom_cuvee_01.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false
        },
        {
          image: 'artisan/Artisan_aura_blossom_vann_cuvee_02.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false
        }
      ]
    },
    {
      id: 's-and-p-artisan-2',
      collectionImages: [
        {
          image: 'artisan/Artisan_6.jpg',
          width: CollectionBannerWidth['25%'],
          fullHeight: false
        },
        {
          image: 'artisan/Artisan_8.jpg',
          width: CollectionBannerWidth['75%'],
          fullHeight: false
        }
      ]
    },
    {
      id: 's-and-p-artisan-3',
      collectionImages: [
        {
          image: 'artisan/Artisan_11 (1).jpg',
          width: CollectionBannerWidth['66%'],
          fullHeight: false
        },
        {
          image: 'artisan/Artisan_10 (1).jpg',
          width: CollectionBannerWidth['33%'],
          fullHeight: false
        }
      ]
    }
  ],
  salesArticleIds: [
    '23712fbf-0ab9-433e-8ab2-984f5309deef',
    '41296a15-627b-4e30-9869-bfac1c81bc08',
    'e914f3a4-1d84-4afc-93e4-05ed6c803428',
    '75ea2fd4-48c2-4e71-a0ca-53dfe688e2f8',
    '4477b0c2-20ec-4cec-be3e-2b89d7d8ec24',
    'ef42d151-b25d-418f-91b1-4e3e7fa96731',
    'c4b59830-ea54-49bc-a4bc-6e2fb4ccb214',
    '7971fb76-9821-46c5-85b0-a770470d16cc',
    '3e36a430-34f3-4246-8b62-de5c890775f4',
    '1fd507f9-abb3-4811-96b7-890ed9f3ebed',
    '0111fa28-3d8b-434c-9f08-48b42fe0b7ca',
    'bb1cc804-c5e9-43ff-9123-ee86dc3e678b',
    'aea9de3d-1332-4d8c-90d1-20e5647f9d58',
    '18ae31cd-c1f2-4f82-b55b-c1c2f25cc51c',
    '2263d8e1-f4fd-43d4-82c5-15e41766af93',
    '2e1966d6-cdbf-400b-8be5-756c033a6987',
    'df5592e4-e8bb-4582-8a65-b4e2a509544b',
    '5e7c4414-4df7-43e9-89c0-21ba8eeb7edd',
    '056317f1-514c-4ea7-82a2-e23ee01f5819',
    'df4c8d9a-792c-4516-8991-9b639c2aba4a',
    '33b72681-619f-4c5f-b04d-f4dd0a3168ac',
    '2e2b9a15-a5e3-4d65-883d-86e3e6243f2c',
    'c7e98113-9d0b-49cd-8ef1-e570765cb12b',
    '7ad0d20c-a97a-4335-87d9-13ad7b3241ab',
    'ccf030d7-4644-4d37-8de9-d1c83b08e4d7',
    'fd12032a-a8e6-4dfe-a037-32dff10a8a00',
    '46b542ea-0698-4180-a807-6f5ce1f880f0',
    '03f00482-bd77-4b01-aeae-31cc56b6debc',
    '6f7b680f-60f2-41f2-bb63-24c56a2e73fb',
    '7e2739a2-ed2b-445f-af1d-c03afb50cbaf',
    '420f8a23-f2a7-4a26-b71e-88762e29705f',
    '77399fd3-3fde-4adf-8fb1-f0d31dbba4fe',
    'e48f16e9-0b9d-4f07-8f73-0f3bc3879f34',
    'e5952129-ff08-42e3-be1b-2799bcc38dfd',
    '425727a9-c983-4c84-bc46-7cfa89dbe2a7',
    'b1c8edee-cc77-44f7-ab27-a720976495da',
    'fe0d4d89-2192-4f95-9862-07799ee5499e',
    '38061e34-68ed-44c2-86a0-d5c73abccaff',
    '3fd5e77b-044b-45cf-b855-75bc7ddfe160',
    'dad5118d-bbd6-4bd0-8407-d206b1d10c95',
    '7e7bcf23-3feb-420c-a2b2-908e8ecf373f',
    '0d9b0e33-54a0-4679-9bc5-369d54213d46',
    '5bacfb4b-6916-46eb-b92a-6e134054233a',
    '92cb7ae1-305a-4641-b234-c660773203c5'
  ]
};
